var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSangue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.9 25.1",
    width: "26px",
    height: "26px",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2-2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.9,18.93a2.68,2.68,0,0,1-5.36,0c0-1.48,2.68-4.21,2.68-4.21S25.9,17.45,25.9,18.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M21.36,8.91,16.25,3.67,1.57,18.35a3.66,3.66,0,0,0,0,5.18h0a3.66,3.66,0,0,0,5.18,0L19.4,10.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M21,8.61l.75.64a1,1,0,0,0,1.45,0l.64-.6a1,1,0,0,0,0-1.5L17.5.81A1,1,0,0,0,16,.81l-.55.55a1,1,0,0,0,0,1.47l.77.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.47,11.09l-9-.63L1.54,18.39a3.62,3.62,0,0,0,0,5.11h0a3.62,3.62,0,0,0,5.17-.07Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSangue);
export default __webpack_public_path__ + "static/media/sangue.d62fc1e55ecffb32e65d575e99fc70d6.svg";
export { ForwardRef as ReactComponent };